import {
    GET_DELIVERY_POINT_ROUTE_LOADING,
    GET_DELIVERY_POINT_ROUTE_SUCCESS,
    GET_DELIVERY_POINT_ROUTE_REJECT,
} from "../../actions/deliveryPointRoute/getAll";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    totalPages: 0, 
    currentPage: 1, 
}

const deliveryPointRouteReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_DELIVERY_POINT_ROUTE_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_DELIVERY_POINT_ROUTE_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_DELIVERY_POINT_ROUTE_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        default: return state;
    }
}

export default deliveryPointRouteReducer